type LocalizedObject<T> = T & { __id: string };

// eslint-disable-next-line custom-rules/no-let
let cnt = 0;

export const localizeObject = <T>(obj: T): LocalizedObject<T> => {
  if (isLocalizedObject(obj)) return obj as LocalizedObject<T>;
  Object.defineProperty(obj, '__id', { value: `${cnt++}` });
  return obj as LocalizedObject<T>;
};

export const isLocalizedObject = <T>(obj: T): obj is LocalizedObject<T> =>
  // eslint-disable-next-line no-underscore-dangle
  typeof obj === 'object' && obj !== null && '__id' in obj && typeof obj.__id === 'string';
